module.exports = __webpack_public_path__ + "static/media/ntma.4df7b9ca7624096aea1133e28fc09a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ntma.png
// module id = 1107
// module chunks = 1